<style lang="less" scoped>

</style>
<template>
  <VRemoteSelect
    :find-key="findKey"
    :value="value"
    :rules="rules"
    :handle-find="handleFind"
    :extra-data="extra_data"
    item-value="bank_number"
    :item-text="itemText"
    :find_api="find_api"
    :search_api="search_api"
    :item-default="{id: 0, bank: '', bank_account: '', bank_number: '', payee_company_id: 0, payee_company_name: ''}"
    :label="label"
    :placeholder="placeholder"
    :clearable="clearable"
    :noDataText="noDataText"
    @input="emitInput"
    @change="emitAccountInfo"
    @click:clear="del"
  />
</template>
<script>
  import VRemoteSelect from '../../../vuetify_custom/v-remote-select-upgrade';
  export default {
    components: { VRemoteSelect },
    props: {
      type: {
        // company: 公司供应商, person: 个人供应商, staff: 公司员工
        type: String,
        required: true
      },
      apply_user_id: {
        type: Number,
        default: 0
      },
      value: {
        type: String,
      },
      rules: {
        type: Array,
        default() {
          return [];
        }
      },
      clearable: {
        type: Boolean,
        default: false
      },
      label: {
        type: String
      },
      placeholder: {
        type: [String, Number],
        default: '搜索'
      },
      itemText: {
        type: [String, Function],
        default:() => (i) => (`${i.bank_number}-${i.bank_account}-${i.bank}`)
      },
      findKey: {
        type: String,
        default: 'search'
      },
      noDataText: {
        type: String,
        default: '没有数据，请搜索'
      }
    },
    computed: {
      extra_data() {
        return {
          type: this.type,
          apply_user_id: this.apply_user_id
        }
      },
      find_api() {
        return this.search_api;
      },
      search_api() {
        if (this.type === 'staff') {
          return 'customer_account/select_search';
        } else {
          return 'payee_company_account/select_search';
        }
      },
    },
    methods: {
      emitInput(val) {
        this.$emit('input', val);
      },
      handleFind(data) {
        return data.accounts || []
      },
      emitAccountInfo(account) {
        const account_obj = {};
        if (this.type === 'staff') {
          account_obj.payee_company_id = 0;
          account_obj.payee_company = '';
          account_obj.payee_company_account_id = 0;
          account_obj.payee_user_id = account.customer_id;
          account_obj.payee_user = account.customer_account;
        } else {
          account_obj.payee_user_id = 0;
          account_obj.payee_user = '';
          account_obj.payee_company_id = account.payee_company_id;
          account_obj.payee_company = account.payee_company_name;
          account_obj.payee_company_account_id = account.id;
        }
        account_obj.payee_bank = account.bank;
        account_obj.payee_account_name = account.bank_account;
        account_obj.payee_bank_number = account.bank_number;
        this.$emit('change', account_obj);
      },
      del() {
        const account_obj = {};
        account_obj.payee_user_id = 0;
        account_obj.payee_user = '';
        account_obj.payee_company_id = 0;
        account_obj.payee_company = '';
        account_obj.payee_company_account_id = 0;
        account_obj.payee_bank = '';
        account_obj.payee_account_name = '';
        account_obj.payee_bank_number = '';
        this.$emit('change', account_obj);
        document.body.click();
      }
    }
  }
</script>
